import { render, staticRenderFns } from "./DriverGroupUsers.vue?vue&type=template&id=a56de836&"
import script from "./DriverGroupUsers.vue?vue&type=script&lang=js&"
export * from "./DriverGroupUsers.vue?vue&type=script&lang=js&"
import style0 from "./DriverGroupUsers.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports